/* Drops the FACEPLANT notification in from the top of the second slide once it
   is actually on screen, so the banner behaves like a phone notification rather
   than something that was already sitting there. */
(function () {
  if (window.__fpCompare) return;
  window.__fpCompare = true;

  function arm() {
    var stages = document.querySelectorAll('.fp-cmp-stage');
    if (!stages.length) return false;

    Array.prototype.forEach.call(stages, function (stage) {
      if (stage.dataset.fpArmed) return;
      stage.dataset.fpArmed = '1';

      var slide = stage.querySelector('.fp-cmp-slide.s2');
      if (!slide) return;

      if (!('IntersectionObserver' in window)) { stage.classList.add('in'); return; }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // a short beat after it lands, so you see it arrive
          if (e.isIntersecting && e.intersectionRatio > 0.55) {
            setTimeout(function () { stage.classList.add('in'); }, 260);
          } else if (!e.isIntersecting) {
            stage.classList.remove('in');   // re-arms on the way back
          }
        });
      }, { threshold: [0, 0.55, 1] });

      io.observe(slide);
    });
    return true;
  }

  // the page is built by faceplant-runtime.js, so the section may not exist yet
  if (!arm()) {
    var tries = 0;
    var poll = setInterval(function () {
      if (arm() || ++tries > 40) clearInterval(poll);
    }, 250);
  }
})();
